export enum PageStatus {
  Initial = 'initial',
  Loading = 'loading',
  Loaded = 'loaded',
  Error = 'error',
  ConnectionError = 'connection_error',
  ForceLogout = 'force_logout',
}
